import * as preact from "preact";

import { type PreactPageProps } from "pages/PreactPage";
import ManageSubscriptionView from "views/ManageSubscriptionView";

/**
 * /accountRenew — the legacy renewal-settings URL, linked from old emails and
 * the premium panel. It now renders the same server-view-model-driven
 * subscription manager as /account: the old renewalMonths select applied
 * plan/cadence changes with no preview or confirmation, bypassing the
 * deploy B billing rules (docs/todos/tasks/stripeRefactor.md).
 */
export default class AccountRenewalPageView extends preact.Component<PreactPageProps> {
  render() {
    return (
      <div class="accountSettingsView">
        <ManageSubscriptionView />
      </div>
    );
  }
}
